import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { eventService } from "../services/EventService";
import { ProgressSpinner } from "primereact/progressspinner";
import ScreenLoader from "./ScreenLoader";
import { AppDB } from "../App";
export default function AddEventGroup({ buttonName = "Save", buttonIcon = "pi pi-save", show = false, setShow, ReloadEventGroups }) {
	var [pageIndex, setPageIndex] = useState(0);
	const [isLoading, setisLoading] = useState(false);
	const {groupEventInfo,setallGroups, toast}= useContext(AppDB)
	
	//console.log(groupEventInfo);
	var [form, setForm] = useState({
		Name: "",
		Description: "",
		// EventDate: "",
		// Status: 1,
		// StatusReason: null,
		// Events: null
	});

	// function formatDate(date) {
	//     var d = new Date(date),
	//         month = "" + (d.getMonth() + 1),
	//         day = "" + d.getDate(),
	//         year = d.getFullYear();

	//     if (month.length < 2) month = "0" + month;
	//     if (day.length < 2) day = "0" + day;

	//     return [year, month, day].join("-");
	// }

	var submittedForm = false;

	async function SubmitForm() {
		setisLoading(true);

		const newForm = { ...form };
		let error = false;

		// Check if any required fields are empty
		for (const [key, value] of Object.entries(newForm)) {
			if (value === "" || value === null || value === undefined) {
				error = true;
				break;
			}
		}

		if (error) {
			setisLoading(false);  
			toast.show({
				severity: "error",
				summary: "Error Message",
				detail: "Please fill in all required fields.",
				life: 3000
			});
			return;  // Exit the function early to prevent submission
		}
	
		try {
			const res = await eventService.createGroup(newForm);

			if (res?.success) {
				ReloadEventGroups();
				toast.show({
					severity: "success",
					summary: "Success Message",
					detail: res?.message,
					life: 2000
				});
				setForm({
					Name: "",
					Description: ""
				});
				setShow(false);
			}
			else{
				toast.show({
					severity: "error",
					summary: "Error Message",
					detail: res?.message,
					life: 2000
				});
			}
		} catch (e) {
			toast.show({
				severity: "error",
				summary: "Error Message",
				detail: "Something went wrong.",
				life: 2000
			});
		} finally {
			setisLoading(false); // Ensure loading is stopped in all cases
			setShow(false);
		}
	}

	return (
		<Dialog
			draggable={false}
			header={
				<>
					<li className="pi pi-plus"> </li>
					<span>Add Event Group</span>
				</>
			}
			footer={
				<>
					{pageIndex == 0 ? (
						<>
							<Button
								label="Submit"
								onClick={SubmitForm}
								className="p-button-success"
								icon="pi pi-plus"
								type="submit"
								loading={isLoading}
							/>
						</>
					) : (
						""
					)}
				</>
			}
			visible={show}
			onHide={(e) => {
				setForm({
					Name: "",
					Description: "",
					Status: 1,
					StatusReason: null,
					Events: null
				});
				setShow(false);
			}}
			style={{ width: "75%", height: "50%" }}
		>
        <ScreenLoader visible={isLoading} />
			<div className="grid">
				<div className="col-12 lg:col-12">
					<form method="post">
						<TabView onTabChange={(e) => (e.index = pageIndex)} activeIndex={pageIndex}>
							<TabPanel header="Event Group Details" disabled={pageIndex == 0 ? false : true}>
								<div className="grid">
									<div className="col-12 lg:col-6">
										<TextInput
											label={
												<>
													Event Group Name <span style={{ color: "red" }}>*</span>
												</>
											}
											value={form.Name}
											onChange={(e) => setForm({ ...form, Name: e.target.value.toUpperCase() })}
										/>
									</div>
									<div className="col-12 lg:col-6">
										<TextInput
											label={
												<>
													Description <span style={{ color: "red" }}>*</span>
												</>
											}
											value={form.Description}
											onChange={(e) => setForm({ ...form, Description: e.target.value.toUpperCase() })}
										/>
									</div>
									{/* <div className="col-12  lg:col-4">
                                        <TextInput type="Calendar" label="EventDate" value={form.EventDate} onChange={(e) => setForm({ ...form, EventDate: e.target.value })} />
                                    </div> */}
								</div>
							</TabPanel>
						</TabView>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
